<script setup>
import MultiSelectComponent from "@/components/MultiSelectComponent.vue";
import useFilterOptions from "@/scripts/Devices/FilterOptions.js";
import { useStore } from "vuex";
import { onMounted } from "vue";

const store = useStore();

onMounted(() => {
  store.dispatch("devicesFilterOptions/fetchFilterOptions");
  store.commit("devices/RESET_DEVICE_QUERY");
  store.commit("devicesFilterOptions/RESET_FILTER_OPTIONS");
});
let ActiveStatus = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

const {
  loading,
  deviceType,
  deviceClass,
  tagAppVersion,
  appVersion,
  deviceTypes,
  deviceClasses,
  sfTagAppVersions,
  sfAppVersions,
} = useFilterOptions("totalDevices");
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <form>
              <div class="card-header">
                <h3 class="card-title">FILTERS OPTIONS:</h3>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Course Status</label>
                      <select class="form-control" v-model="ActiveStatus">
                        <option value="">Select Status</option>
                        <option value="unassigned">Active</option>
                        <option value="assigned">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Device Class</label>
                      <MultiSelectComponent
                        v-model="deviceType"
                        :options="deviceTypes"
                        label="name"
                        track-by="id"
                        placeholder="Select Device Type"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Device Type</label>
                      <MultiSelectComponent
                        v-model="deviceClass"
                        :options="deviceClasses"
                        label="name"
                        track-by="id"
                        placeholder="Select Device Class"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Tagmarshal App Version</label>
                      <MultiSelectComponent
                        v-model="tagAppVersion"
                        :options="sfTagAppVersions"
                        label="sf_tagmarshal_app_version"
                        track-by="sf_tagmarshal_app_version"
                        placeholder="Select Tagmarshal App Version"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Scale Fusion Version</label>
                      <MultiSelectComponent
                        v-model="appVersion"
                        :options="sfAppVersions"
                        label="sf_app_version"
                        track-by="sf_app_version"
                        placeholder="Select Scale Fusion Version"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-block btn-success"
                        :disabled="loading"
                      >
                        <font-awesome-icon
                          v-show="loading"
                          :icon="['fas', 'spinner']"
                          spin
                        />
                        <span v-show="!loading">Filter Report</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
